// IE11
import 'url-search-params-polyfill';

/**
 * Get the URL parameters
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
const getQueryParams = (url) => {
  let searchParams

  try {
    const decodedUrl = decodeURIComponent(url)
    const urlInstance = new URL(decodedUrl)
    searchParams = new URLSearchParams(urlInstance.search);
  } catch (error) {
    throw error;
  }

  const queryParams = {};

  // Display the key/value pairs
  // eslint-disable-next-line no-restricted-syntax
  for (const pair of searchParams.entries()) {
    const key = pair[0]
    const value = pair[1]
    queryParams[key] = value
  }

  return queryParams
};

export default getQueryParams
